import { Box } from "@itandi/itandi-bb-ui/Box";
import Styles from "./statuses.module.scss";

export function Finished() {
	return (
		<div>
			<h3 className={Styles.Title}>完了しました</h3>
			<Box marginY={16}>
				<p>すべての工事工程が完了しました。</p>
			</Box>
		</div>
	);
}
